import { Flex, Skeleton, Link, useBreakpointValue, Button, Box } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import NextLink from 'next/link';
import { FC, Fragment, useState } from 'react';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { queryAllLectureProfilesByLectureId } from '@/fetchers/lectureProfiles';
import { LectureProfile } from '@/resources/LectureProfile';

export const AuthorsList: FC = () => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const maxToShow = useBreakpointValue({ base: 10, md: 16, lg: 18 });
  const { id: lectureId } = useLecturePageQueryParams();

  const { data: lectureProfiles, isValidating } = useResources(queryAllLectureProfilesByLectureId(lectureId));

  const showShowMoreButton = lectureProfiles?.length > maxToShow;

  const arrayToShow = expanded ? lectureProfiles : lectureProfiles?.slice(0, maxToShow);

  return (
    <Box mt={2}>
      <Flex flexWrap="wrap">
        {!isValidating && <AuthorLinks lectureProfiles={arrayToShow} />}
        {isValidating && <Skeleton height={5} w="full" />}
      </Flex>
      {!isValidating && showShowMoreButton && (
        <Button height={12} variant="unstyled" onClick={() => setExpanded((e) => !e)}>
          show {expanded ? 'less' : 'more'} authors
        </Button>
      )}
    </Box>
  );
};

const AuthorLinks: FC<{ lectureProfiles: Array<LectureProfile> }> = ({ lectureProfiles }) => {
  return (
    <Fragment>
      {lectureProfiles?.map((lectureProfile, index) => (
        <Fragment key={lectureProfile.profile.id}>
          <NextLink href={`/speakers/${lectureProfile.profile?.linkSlug}`} passHref>
            <Link>{lectureProfile.profile.fullName}</Link>
          </NextLink>
          {index < lectureProfiles.length - 1 && <span>,&nbsp;</span>}
        </Fragment>
      ))}
    </Fragment>
  );
};
